import { useState, useCallback, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useRTLContext from "../../../../../hooks/useRTLContext";

export function useStatusOptions({}) {
  const { t } = useTranslation();
  const { isRTL } = useRTLContext();

  const translatedStatusOptions = useMemo(() => {
    return [
      { value: "active", label: isRTL ? t("Active") : "Active" },
      { value: "inactive", label: isRTL ? t("Inactive") : "Inactive" },
    ];
  }, [isRTL, t]);

  const [statusOptions, setStatusOptions] = useState(translatedStatusOptions);
  const [selectedStatus, setSelectedStatus] = useState("");

  // Update translated options only if changed
  useEffect(() => {
    setStatusOptions(translatedStatusOptions);

    // Match and update selectedStatus if label changed
    if (selectedStatus?.value) {
      const updatedSelected = translatedStatusOptions.find(
        (opt) => opt.value === selectedStatus.value
      );

      // Only update if label actually changed
      if (updatedSelected && updatedSelected.label !== selectedStatus.label) {
        setSelectedStatus(updatedSelected);
      }
    }
  }, [translatedStatusOptions, selectedStatus]);

  const onSearchStatusDebounce = useCallback(
    (inputValue, callback) => {
      const filtered = translatedStatusOptions.filter((option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filtered);
    },
    [translatedStatusOptions]
  );

  return {
    statusOptions,
    selectedStatus,
    setSelectedStatus,
    onSearchStatusDebounce,
  };
}
